import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://6c23d251c1a978a65532a9683564a646@o210841.ingest.us.sentry.io/4511087372795904",
  tunnel: '/api/tunnel',
  sendDefaultPii: false,
  environment: import.meta.env.PROD ? 'production' : 'local',
  enabled: import.meta.env.PROD === 'production',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  enableLogs: true,
  tracesSampleRate: 1.0,
  tracePropagationTargets: [/^\//],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
